import { Component, OnInit, Input } from '@angular/core';
import { DocTucThoiDiemDoService } from '../../services';

@Component({
  selector: 'app-doctucthoi', 
  templateUrl: './doctucthoi.component.html',
  styles: [`.ui-radiobutton-box{
    height:1.185em !important;
  }

.timerdiv{
  height:100px;
  border-radius: 50%;
  
}
.timerdiv1{
  width:100px;
  height:100px;
  border-radius:50%;
  border:double 7px;
  color: #40b7fd !important;
}
.Timer {
  background-color:#4dbd74;
  line-height: 86px;
  border-radius:50%;
  font-size: 13px;
}
.Timer1 {
  background-color:#40b7fd;
  line-height: 86px;
  border-radius:50%;
  font-size: 13px;
}
  `],
})
export class DocTucThoiComponent implements OnInit {
  @Input() loaipha: number = 1;
  @Input() meterid: number;
  @Input() tenkhachhang: any = "";
  @Input() socongto: any = "";
  kieuDoc = "TTEN";
  thoiDiem = "";
  loaiCongTo = 1;
  interval: any;
  item: any;
  second = 0;
  readCount = 0;
  minute = 0;
  isComplete = false;
  isStop = true;
  isShowTimer: boolean = false;
  constructor(private docTucThoiService: DocTucThoiDiemDoService) { }

  ngOnInit() {
    this.loaiCongTo = this.loaipha;
    this.item = {
      "tenkhachhang": this.tenkhachhang,
      "socongto": this.socongto,
      "meterid": this.meterid,
      "bieugia": "",
      "pgiaotong": "",
      "pnhantong": "",
      "qgiaotong": "",
      "qnhantong": "",
      "pgiao1": "",
      "pgiao2": "",
      "pgiao3": "",
      "pnhan1": "",
      "pnhan2": "",
      "pnhan3": "",
      "qgiao1": "",
      "qgiao2": "",
      "qgiao3": "",
      "qnhan1": "",
      "qnhan2": "",
      "qnhan3": "",
      "pmax1": "",
      "pmax2": "",
      "pmax3": "",
      "pmax1_time": "",
      "pmax2_time": "",
      "pmax3_time": "",
      "sukien": "",
      "ua": "",
      "ub": "",
      "uc": "",
      "ia": "",
      "ib": "",
      "ic": "",
      "cosa": "",
      "cosb": "",
      "cosc": "",
      "pa": "",
      "pb": "",
      "pc": "",
      "qa": "",
      "qb": "",
      "qc": "",
      "chiso": "",
      "thoigiandoc": "",
      "trangthai": "PENDING",
    };
  }

  docTucThoi() {
    this.isStop = false;
    this.readCount = 1;
    this.second = 0;
    this.minute = 0;
    this.item.trangthai = "READING";
    this.isShowTimer = true;
    if (this.loaiCongTo == 1) {
      this.docTucThoiService.layThongTin1Pha(this.meterid, 0, this.kieuDoc).subscribe(res => {
        let _ret = JSON.parse(res);
        this.interval = setInterval(() => {
          this.second++;
          if (this.second == 60) {
            this.minute++;
            this.second = 0;
          }
          this.loadThongTinMeterID(_ret);
        }, 1000);
      });

    }
    else {
      this.docTucThoiService.layThongTin3Pha(this.meterid, 0, this.kieuDoc).subscribe(res => {
        let _ret = JSON.parse(res);
        this.interval = setInterval(() => {
          let thoiDiem = _ret.data[0].thoidiem;
          this.second++;
          if (this.second == 60) {
            this.minute++;
            this.second = 0;
          }
          this.loadThongTinMeterID_3Pha(this.meterid, thoiDiem);
        }, 1000);
      });
    }
  }

  loadThongTinMeterID(_ret) {
    //lay thong tin meter id 1 pha
    if (_ret[1].result_table_1.length > 0) {

      this.thoiDiem = _ret[1].result_table_1[0].thoidiem;
      this.docTucThoiService.layKetQua(this.meterid, this.thoiDiem, this.kieuDoc, this.loaiCongTo, 0).subscribe(res => {
        let ret = JSON.parse(res);
        if (ret.data.length > 0) {
          this.isComplete = true;
          this.dungDoc();
          let ketqua = ret.data[0];
          this.item.pgiaotong = ketqua.pgiaotong;
          this.item.pnhantong = ketqua.pnhantong;
          this.item.qgiaotong = ketqua.qgiaotong;
          this.item.qnhantong = ketqua.qnhantong;
          this.item.pmax1 = ketqua.pmax1;
          this.item.pmax2 = ketqua.pmax2;
          this.item.pmax3 = ketqua.pmax3;
          this.item.pmax1_time = ketqua.pmax1_time;
          this.item.pmax2_time = ketqua.pmax2_time;
          this.item.pmax3_time = ketqua.pmax3_time;
          this.item.sukien = ketqua.name_sukien;
          this.item.ua = ketqua.ua;
          this.item.ub = ketqua.ub;
          this.item.uc = ketqua.uc;
          this.item.ia = ketqua.ia;
          this.item.ib = ketqua.ib;
          this.item.ic = ketqua.ic;
          this.item.cosa = ketqua.cosa;
          this.item.cosb = ketqua.cosb;
          this.item.cosc = ketqua.cosc;
          this.item.pa = ketqua.pa;
          this.item.pb = ketqua.pb;
          this.item.pc = ketqua.pc;
          this.item.qa = ketqua.qa;
          this.item.qb = ketqua.qb;
          this.item.qc = ketqua.qc;
          this.item.pgiao1 = ketqua.pgiao1;
          this.item.pgiao2 = ketqua.pgiao2;
          this.item.pgiao3 = ketqua.pgiao3;
          this.item.pnhan1 = ketqua.pnhan1;
          this.item.pnhan2 = ketqua.pnhan2;
          this.item.pnhan3 = ketqua.pnhan3;
          this.item.qgiao1 = ketqua.qgiao1;
          this.item.qgiao2 = ketqua.qgiao2;
          this.item.qgiao3 = ketqua.qgiao3;
          this.item.qnhan1 = ketqua.qnhan1;
          this.item.qnhan2 = ketqua.qnhan2;
          this.item.qnhan3 = ketqua.qnhan3;
          this.item.sukien = ketqua.event;
          this.item.trangthai = "OK";
          this.item.chiso = ketqua.pgiaotong;
          this.item.thoigiandoc = ketqua.timeread;
        }
      });
    }
  }

  loadThongTinMeterID_3Pha(listID, thoidiem) {
    this.docTucThoiService.layKetQua(listID, thoidiem, this.kieuDoc, this.loaiCongTo, 0).subscribe(res => {
      let ret = JSON.parse(res);
      let element = ret.data[0];
      if (ret.data.length > 0) {
        this.isComplete = true;
        this.dungDoc();

        this.item.pgiaotong = element.pgiaotong;
        this.item.pnhantong = element.pnhantong;
        this.item.qgiaotong = element.qgiaotong;
        this.item.qnhantong = element.qnhantong;
        this.item.pmax1 = element.pmax1;
        this.item.pmax2 = element.pmax2;
        this.item.pmax3 = element.pmax3;
        this.item.pmax1_time = element.pmax1_time;
        this.item.pmax2_time = element.pmax2_time;
        this.item.pmax3_time = element.pmax3_time;
        this.item.sukien = element.name_sukien;
        this.item.ua = element.ua;
        this.item.ub = element.ub;
        this.item.uc = element.uc;
        this.item.ia = element.ia;
        this.item.ib = element.ib;
        this.item.ic = element.ic;
        this.item.cosa = element.cosa;
        this.item.cosb = element.cosb;
        this.item.cosc = element.cosc;
        this.item.sukien = element.event;
        this.item.pa = element.pa;
        this.item.pb = element.pb;
        this.item.pc = element.pc;
        this.item.qa = element.qa;
        this.item.qb = element.qb;
        this.item.qc = element.qc;
        this.item.pgiao1 = element.pgiao1;
        this.item.pgiao2 = element.pgiao2;
        this.item.pgiao3 = element.pgiao3;
        this.item.pnhan1 = element.pnhan1;
        this.item.pnhan2 = element.pnhan2;
        this.item.pnhan3 = element.pnhan3;
        this.item.qgiao1 = element.qgiao1;
        this.item.qgiao2 = element.qgiao2;
        this.item.qgiao3 = element.qgiao3;
        this.item.qnhan1 = element.qnhan1;
        this.item.qnhan2 = element.qnhan2;
        this.item.qnhan3 = element.qnhan3;
        this.item.trangthai = "OK";
        this.item.chiso = element.pgiaotong;
        this.item.thoigiandoc = element.timeread;
      }
    });
  }

  changeKieuDoc() {
    this.readCount = 0;
    this.minute = 0;
    this.second = 0;
    this.isComplete = false;
    this.item = {
      "tenkhachhang": this.tenkhachhang,
      "socongto": this.socongto,
      "meterid": this.meterid,
      "bieugia": "",
      "pgiaotong": "",
      "pnhantong": "",
      "qgiaotong": "",
      "qnhantong": "",
      "pgiao1": "",
      "pgiao2": "",
      "pgiao3": "",
      "pnhan1": "",
      "pnhan2": "",
      "pnhan3": "",
      "qgiao1": "",
      "qgiao2": "",
      "qgiao3": "",
      "qnhan1": "",
      "qnhan2": "",
      "qnhan3": "",
      "pmax1": "",
      "pmax2": "",
      "pmax3": "",
      "pmax1_time": "",
      "pmax2_time": "",
      "pmax3_time": "",
      "sukien": "",
      "ua": "",
      "ub": "",
      "uc": "",
      "ia": "",
      "ib": "",
      "ic": "",
      "cosa": "",
      "cosb": "",
      "cosc": "",
      "pa": "",
      "pb": "",
      "pc": "",
      "qa": "",
      "qb": "",
      "qc": "",
      "chiso": "",
      "thoigiandoc": "",
      "trangthai": "",
    };
  }

  dungDoc() {
    clearInterval(this.interval);
    this.isShowTimer = false;
    this.isStop = true;
    if(!this.isComplete)
    {
      this.item.trangthai = "FAIL";
    }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/doc-tuc-thoi/doctucthoi.component.ts